import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PartnerList from './list';
import PartnerDetails from './details';

class Partners extends Component {
    render() {
        return (
            <Switch>
                <Route path={`${this.props.match.url}/:id`} component={PartnerDetails} />
                <Route path={`${this.props.match.url}`} component={PartnerList} />
            </Switch>
        );
    }
}

export default Partners;
